var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45829 21.3301H3.58329C2.38668 21.3301 1.41663 20.36 1.41663 19.1634V3.99674C1.41663 2.80013 2.38668 1.83008 3.58329 1.83008H14.4166C15.6132 1.83008 16.5833 2.80013 16.5833 3.99674V7.24674M12.25 14.8301C12.25 13.0352 13.705 11.5801 15.5 11.5801C17.2949 11.5801 18.75 13.0352 18.75 14.8301M12.25 18.0801C12.25 19.875 13.705 21.3301 15.5 21.3301C17.2949 21.3301 18.75 19.875 18.75 18.0801M15.5 15.9134V16.9967M5.74996 6.16341H12.25M5.74996 10.4967H7.91663",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanProducts);
export default __webpack_public_path__ + "static/media/loan-products.69ac138e6ded2dbb3fe6e3bd102caa8f.svg";
export { ForwardRef as ReactComponent };